// extracted by mini-css-extract-plugin
module.exports = {"container":"Favorites_container__32HA1","list":"Favorites_list__1X_Eq"};